// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__mR8Gp","validationTips":"StatementDescriptor_validationTips__SvQMC"};